module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    attrs: {
      "data": _vm.partsData,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "位置",
      "prop": "position"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("mPosition")(scope.row.position)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "type"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("layout")(scope.row.type)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表单",
      "prop": "module_id",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.modelsById[scope.row.model_id]))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "prop": "sort"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.setCurPart(scope.row, scope.$index)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.delPart(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11fa68a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/page/partsTable.vue
// module id = 1778
// module chunks = 2